import { FileIconType } from "@fluentui/react-file-type-icons";
import { SharePointFolderContentTypeIds } from "../../config/constants";
import { IFolderInfo } from "../../interfaces/IFolderInfo";
import { FolderTypeEnum } from "../enums/FolderTypeEnum";
import { FolderTypeIconEnum } from "../enums/FolderTypeIconEnum";
import { ImageTypeEnum } from "../enums/ImageTypeEnum";
import { ImageSizeEnum } from "../enums/ImageSizeEnum";

export class FolderTypeIconQuery {
    private static FolderTypeIconToTypeDictionary = {
        [FolderTypeIconEnum.default.toString()]: FolderTypeEnum.default,
        [FolderTypeIconEnum.sharepointFolder.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.sharepointSite.toString()]: FolderTypeEnum.sharepointSite,
        [FolderTypeIconEnum.documentLibrary.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.oneDrive.toString()]: FolderTypeEnum.oneDrive,
        [FolderTypeIconEnum.teamChannel.toString()]: FolderTypeEnum.teamChannel,
        [FolderTypeIconEnum.teamMainSite.toString()]: FolderTypeEnum.teamMainSite,
        [FolderTypeIconEnum.oneDriveSubFolder.toString()]: FolderTypeEnum.oneDriveSubFolder,
        [FolderTypeIconEnum.sharepointDocumentSet.toString()]: FolderTypeEnum.sharepoint,
        [FolderTypeIconEnum.sharepointList.toString()]: FolderTypeEnum.sharepointList,
        [FolderTypeIconEnum.sharepointHubSite.toString()]: FolderTypeEnum.sharepointHubSite,
        [FolderTypeIconEnum.docubird.toString()]: FolderTypeEnum.docubird
    }

    private static FolderTypeIconToImageUrl = {
        // [FolderTypeIconEnum.default.toString()]: { imageType: ImageTypeEnum.url, location: "https://static2.sharepointonline.com/files/fabric/assets/item-types/20/folder.png" },
        // [FolderTypeIconEnum.sharepointFolder.toString()]: { imageType: ImageTypeEnum.url, location: "./assets/sharePoint-folder-20.png" },
        // [FolderTypeIconEnum.oneDrive.toString()]: { imageType: ImageTypeEnum.url, location: "./assets/oneDrive-folder-20.png" },
        // [FolderTypeIconEnum.teamFolder.toString()]: { imageType: ImageTypeEnum.url, location: "./assets/teams-folder-20.png" },
        [FolderTypeIconEnum.default.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.sharepointFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.oneDrive.toString()]: { imageType: ImageTypeEnum.url, location: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/onedrive_20x1.svg" },
        [FolderTypeIconEnum.oneDriveSubFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.teamFolder.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.folder },
        [FolderTypeIconEnum.sharepointSite.toString()]: { imageType: ImageTypeEnum.url, location: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/sharepoint_20x1.svg" },
        [FolderTypeIconEnum.documentLibrary.toString()]: { imageType: ImageTypeEnum.font, iconName: "DocLibrary" },
        [FolderTypeIconEnum.teamMainSite.toString()]: { imageType: ImageTypeEnum.url, location: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/teams_20x1.svg" },
        [FolderTypeIconEnum.teamChannel.toString()]: { imageType: ImageTypeEnum.font, iconName: "TeamsLogo" },
        [FolderTypeIconEnum.sharepointDocumentSet.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.docset },
        [FolderTypeIconEnum.sharepointList.toString()]: { imageType: ImageTypeEnum.fileType, fileIconType: FileIconType.list },
        [FolderTypeIconEnum.sharepointHubSite.toString()]: { imageType: ImageTypeEnum.font, iconName: "SharepointLogo" },
        [FolderTypeIconEnum.docubird.toString()]: { imageType: ImageTypeEnum.url, location: `${process.env.baseUri}/assets/icon-20.png` }
    }

    static getFolderType = (folderTypeIcon: FolderTypeIconEnum) => {
        if (folderTypeIcon) {
            return FolderTypeIconQuery.FolderTypeIconToTypeDictionary[folderTypeIcon.toString()];
        }
        return FolderTypeEnum.default;
    }

    static getImage = (folderTypeIcon: FolderTypeIconEnum) => {
        if (folderTypeIcon) {
            return FolderTypeIconQuery.FolderTypeIconToImageUrl[folderTypeIcon.toString()];
        }
        return FolderTypeIconQuery.FolderTypeIconToImageUrl[FolderTypeIconEnum.default.toString()];
    }

    static getIconType = (folderType: FolderTypeEnum, info: IFolderInfo, isTeamFolder: boolean = false): FolderTypeIconEnum => {
        switch (folderType) {
            case FolderTypeEnum.default:
                return FolderTypeIconEnum.default
            case FolderTypeEnum.sharepoint:
                return FolderTypeIconQuery.determineSharePointIconType(info, isTeamFolder)
            case FolderTypeEnum.sharepointSite:
                return FolderTypeIconEnum.sharepointSite
            case FolderTypeEnum.oneDrive:
                return FolderTypeIconEnum.oneDrive
            case FolderTypeEnum.teamChannel:
                return FolderTypeIconEnum.teamChannel
            case FolderTypeEnum.teamMainSite:
                return FolderTypeIconEnum.teamMainSite
            case FolderTypeEnum.oneDriveSubFolder:
                return FolderTypeIconEnum.oneDriveSubFolder
            case FolderTypeEnum.sharepointList:
                return FolderTypeIconEnum.sharepointList
            case FolderTypeEnum.sharepointHubSite:
                return FolderTypeIconEnum.sharepointHubSite
            case FolderTypeEnum.docubird:
                return FolderTypeIconEnum.docubird
        }
    }

    private static determineSharePointIconType = (info: IFolderInfo, isTeamFolder: boolean): FolderTypeIconEnum => {
        if (info.driveId && !info?.id) return FolderTypeIconEnum.documentLibrary;
        if (isTeamFolder) return FolderTypeIconEnum.teamFolder;
        if (info.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet)) return FolderTypeIconEnum.sharepointDocumentSet;
        return FolderTypeIconEnum.sharepointFolder
    }
}